module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-02-m-jp.e8f5116d37f15555d2027c98829cfb0c.png";